/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreNasCreateAliases {
  AUTOCOMPLETE_HOUR = 'autocomplete-hour',
  FETCH_HOUR = 'fetch-hour',
  FIELD_ADMIN_TASKS_A = 'field-admin-tasks-a',
  FIELD_ADMIN_TASKS_B = 'field-admin-tasks-b',
  FIELD_ADMIN_TASKS_C = 'field-admin-tasks-c',
  FIELD_DRAIN = 'field-drain',
  FIELD_HOUR = 'field-hour',
  FIELD_HYGIENE_A = 'field-hygiene-a',
  FIELD_HYGIENE_B = 'field-hygiene-b',
  FIELD_HYGIENE_C = 'field-hygiene-c',
  FIELD_LABORATORY_INVESTIGATION_A = 'field-laboratory-investigation-a',
  FIELD_MEDICATION = 'field-medication',
  FIELD_METABOLIC_SUPPORT_A = 'field-metabolic-support-a',
  FIELD_METABOLIC_SUPPORT_B = 'field-metabolic-support-b',
  FIELD_METABOLIC_SUPPORT_C = 'field-metabolic-support-c',
  FIELD_MOBILITY_A = 'field-mobility-a',
  FIELD_MOBILITY_B = 'field-mobility-b',
  FIELD_MOBILITY_C = 'field-mobility-c',
  FIELD_MONITORING_CONTROL_A = 'field-monitoring-control-a',
  FIELD_MONITORING_CONTROL_B = 'field-monitoring-control-b',
  FIELD_MONITORING_CONTROL_C = 'field-monitoring-control-c',
  FIELD_NEUROLOGIC_SUPPORT = 'field-neurologic-support',
  FIELD_RENAL_SUPPORT_A = 'field-renal-support-a',
  FIELD_RENAL_SUPPORT_B = 'field-renal-support-b',
  FIELD_SETUP_DATE = 'field-setup-date',
  FIELD_SPECIAL_INTERVETIONS = 'field-special-intervetions',
  FIELD_SPECIAL_INTERVETIONS_B = 'field-special-intervetions-b',
  FIELD_SUPPORT_A = 'field-support-a',
  FIELD_SUPPORT_B = 'field-support-b',
  FIELD_SUPPORT_CARDIO_A = 'field-support-cardio-a',
  FIELD_SUPPORT_CARDIO_B = 'field-support-cardio-b',
  FIELD_SUPPORT_CARDIO_C = 'field-support-cardio-c',
  FIELD_SUPPORT_CARDIO_D = 'field-support-cardio-d',
  FIELD_SUPPORT_VENTILATORY_A = 'field-support-ventilatory-a',
  FIELD_SUPPORT_VENTILATORY_B = 'field-support-ventilatory-b',
  FIELD_SUPPORT_VENTILATORY_C = 'field-support-ventilatory-c',
  FIELD_TEXT_ADMIN_TASKS = 'field-text-admin-tasks',
  FIELD_TEXT_HYGIENE = 'field-text-hygiene',
  FIELD_TEXT_LABORATORY_INVESTIGATION = 'field-text-laboratory-investigation',
  FIELD_TEXT_METABOLIC_SUPPORT = 'field-text-metabolic-support',
  FIELD_TEXT_MOBILIZATION = 'field-text-mobilization',
  FIELD_TEXT_MONITORING_CONTROL = 'field-text-monitoring-control',
  FIELD_TEXT_NEUROLOGIC_SUPPORT = 'field-text-neurologic-support',
  FIELD_TEXT_RENAL_SUPPORT = 'field-text-renal-support',
  FIELD_TEXT_SPECIAL_INTERVETIONS = 'field-text-special-intervetions',
  FIELD_TEXT_SUPPORT = 'field-text-support',
  FIELD_TEXT_SUPPORT_CARDIO = 'field-text-support-cardio',
  FIELD_TEXT_SUPPORT_VENTILATORY = 'field-text-support-ventilatory',
  FORM_CONTEXTUAL_BAR = 'form-contextual-bar',
  FORM_FIVE = 'form-five',
  FORM_FOUR = 'form-four',
  FORM_ONE = 'form-one',
  FORM_SIX = 'form-six',
  FORM_THREE = 'form-three',
  FORM_TWO = 'form-two',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_SETUP_DATE = 'input-setup-date',
  MAPPER_HOUR = 'mapper-hour',
  PANEL_BODY = 'panel-body',
  PANEL_HEADER = 'panel-header',
  RADIO_ADMIN_TASKS_B = 'radio-admin-tasks-b',
  RADIO_ADMIN_TASKS_C = 'radio-admin-tasks-c',
  RADIO_GROUP_ADMIN_TASKS_A = 'radio-group-admin-tasks-a',
  RADIO_GROUP_DRAIN = 'radio-group-drain',
  RADIO_GROUP_HYGIENE_A = 'radio-group-hygiene-a',
  RADIO_GROUP_HYGIENE_B = 'radio-group-hygiene-b',
  RADIO_GROUP_HYGIENE_C = 'radio-group-hygiene-c',
  RADIO_GROUP_LABORATORY_INVESTIGATION_A = 'radio-group-laboratory-investigation-a',
  RADIO_GROUP_MEDICATION = 'radio-group-medication',
  RADIO_GROUP_METABOLIC_SUPPORT_A = 'radio-group-metabolic-support-a',
  RADIO_GROUP_METABOLIC_SUPPORT_B = 'radio-group-metabolic-support-b',
  RADIO_GROUP_METABOLIC_SUPPORT_C = 'radio-group-metabolic-support-c',
  RADIO_GROUP_MOBILITY_A = 'radio-group-mobility-a',
  RADIO_GROUP_MOBILITY_B = 'radio-group-mobility-b',
  RADIO_GROUP_MOBILITY_C = 'radio-group-mobility-c',
  RADIO_GROUP_MONITORING_CONTROL_A = 'radio-group-monitoring-control-a',
  RADIO_GROUP_MONITORING_CONTROL_B = 'radio-group-monitoring-control-b',
  RADIO_GROUP_MONITORING_CONTROL_C = 'radio-group-monitoring-control-c',
  RADIO_GROUP_NEUROLOGIC_SUPPORT = 'radio-group-neurologic-support',
  RADIO_GROUP_RENAL_SUPPORT_A = 'radio-group-renal-support-a',
  RADIO_GROUP_RENAL_SUPPORT_B = 'radio-group-renal-support-b',
  RADIO_GROUP_SPECIAL_INTERVETIONS_A = 'radio-group-special-intervetions-a',
  RADIO_GROUP_SPECIAL_INTERVETIONS_B = 'radio-group-special-intervetions-b',
  RADIO_GROUP_SUPPORT_CARDIO_A = 'radio-group-support-cardio-a',
  RADIO_SUPPORT_A = 'radio-support-a',
  RADIO_SUPPORT_B = 'radio-support-b',
  RADIO_SUPPORT_CARDIO_B = 'radio-support-cardio-b',
  RADIO_SUPPORT_CARDIO_C = 'radio-support-cardio-c',
  RADIO_SUPPORT_CARDIO_D = 'radio-support-cardio-d',
  RADIO_SUPPORT_VENTILATORY_A = 'radio-support-ventilatory-a',
  RADIO_SUPPORT_VENTILATORY_B = 'radio-support-ventilatory-b',
  RADIO_SUPPORT_VENTILATORY_C = 'radio-support-ventilatory-c',
  SCORE_NAS_ADD_LAYOUT = 'score-nas-add-layout',
  TEXT_HOUR = 'text-hour',
  WIZARD = 'wizard',
  WIZARD_STEP_FIVE = 'wizard-step-five',
  WIZARD_STEP_FOUR = 'wizard-step-four',
  WIZARD_STEP_ONE = 'wizard-step-one',
  WIZARD_STEP_SIX = 'wizard-step-six',
  WIZARD_STEP_THREE = 'wizard-step-three',
  WIZARD_STEP_TWO = 'wizard-step-two',
}
export { ScoreNasCreateAliases };
